import { faker } from '@faker-js/faker'

export const SITE_CUSTOM_PROPERTIES_MOCK_RESPONSE = {
  siteCustomProperties: [
    {
      id: faker.string.uuid(),
      v1Id: Number(faker.string.numeric(1)),
      name: faker.lorem.words(),
    },
  ],
}
